"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterFormsyProps = filterFormsyProps;
exports.getBorderColor = getBorderColor;
exports.getCharsRemaining = getCharsRemaining;
exports.getValidationErrorsString = getValidationErrorsString;

var _humanizePlus = require("humanize-plus");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getBorderColor({
  $disabled,
  $error,
  $isFocused,
  $theme
}) {
  if ($disabled) {
    return $theme.colors.grey30;
  } else if ($error) {
    return $theme.colors.negative;
  } else if ($isFocused) {
    return $theme.colors.primary;
  } else {
    return $theme.colors.grey40;
  }
}
/**
 * Get a formatted validation errors string for a
 * formsy component
 */


function getValidationErrorsString(props) {
  const {
    errorMessages,
    isPristine
  } = props;
  if (isPristine) return null;
  if ((0, _isEmpty.default)(errorMessages)) return null;
  return `${(0, _humanizePlus.capitalize)((0, _humanizePlus.oxford)(errorMessages))}.`;
} // I don't have a full grasp on how this works, but I got the idea from here
// https://stackoverflow.com/a/51855652


/**
 * Filters out formsy props from props.
 * Props copied from https://github.com/formsy/formsy-react/blob/master/API.md
 */
function filterFormsyProps(props) {
  const {
    // WrapperProps
    innerRef,
    name,
    required,
    validationError,
    validationErrors,
    validations,
    value,
    // InjectedProps
    errorMessage,
    errorMessages,
    hasValue,
    isFormDisabled,
    isFormSubmitted,
    isPristine,
    isRequired,
    isValid,
    isValidValue,
    ref,
    resetValue,
    setValidations,
    setValue,
    showError,
    showRequired,
    ...restProps
  } = props;
  const formsyProps = {
    // WrapperProps
    innerRef,
    name,
    required,
    validationError,
    validationErrors,
    validations,
    value,
    // InjectedProps
    errorMessage,
    errorMessages,
    hasValue,
    isFormDisabled,
    isFormSubmitted,
    isPristine,
    isRequired,
    isValid,
    isValidValue,
    ref,
    resetValue,
    setValidations,
    setValue,
    showError,
    showRequired
  }; // @ts-ignore: Not sure how to make this check internally, but it works
  // externally

  return [formsyProps, restProps];
}

function getCharsRemaining(value, maxLength) {
  if (value == null || maxLength == undefined) return null;
  return maxLength - value.length;
}